import SectorQueue from './SectorQueue'

function Sewing() {
    return <SectorQueue sector="Costura" />
}

export default Sewing
